import config from './config'
import {Message} from '@arco-design/web-vue'
import axios from 'axios'
import util from '../util'
import i18n from '../../lang'
import router from '../../router'

export default {
    request(url, data = {}, method = "GET", retryCount = 0) {
        let lang = util.getCache('lang', config.default_lang);
        if(lang === 'zh' || lang === 'zh_Hant'){
            lang = 'zh_CN';
        }
        let token = util.getCache('token');
        const silent500Urls = ['api/contract/list', 'api/currency/accountCurrency']; // 定义需要静默处理500的URL
        const passThroughErrorUrls = [
            'api/account/sendEmailCode',
            'api/account/emailRegister',
            'api/account/sendPhoneCode',
            'api/account/phoneRegister',
        ];

        let device = 2;
        let timestamp = Date.parse(new Date()) / 1000;
        return new Promise((resolve, reject) => {
            axios({
                method: method,
                url: config.BASE_URL + '/' + url,
                data: data,
                params:method === "GET" ? data : {},
                timeout: 15000, // 增加超时时间
                headers: {
                    "Accept-Language": lang,
                    "Authorization": "Bearer " + token,
                    "Client-Device": device,
                    "Timestamp": timestamp,
                },
                withCredentials: false,
            }).then(function (response) {
                let resData = response.data // 重命名避免与传入的data冲突

                // 处理业务 Code 500/1001
                if (resData.code === 1001 || resData.code === 500) {
                     // 对注册/验证码接口，直接把后端错误透传到页面，不做静默/默认数据
                     if (passThroughErrorUrls.includes(url)) {
                         return resolve({ ...resData, success: false });
                     }
                     console.log(`API ${url} 返回 code ${resData.code}`); // 使用 log 替代 error
                     // 重试逻辑 (可选，但应在静默处理之后)
                     if (retryCount < 2 && (url.includes('/currency') || url.includes('/dep')) && !silent500Urls.includes(url)) {
                         console.log(`自动重试 ${url}, 重试次数: ${retryCount + 1}`);
                         // 使用 return resolve(...) 来进行重试
                         return resolve(this.request(url, data, method, retryCount + 1));
                     }

                     // **核心修改点 1**: 只有非静默 URL 的 500 code 才弹框
                     if (!silent500Urls.includes(url)) {
                         Message.error({ content: i18n.global.t('server_error') });
                     }

                     // 统一返回默认数据结构
                     let defaultData = {};
                     if (url === 'api/contract/list') {
                         defaultData = {position: [], entrust: [], entrustP: [], totalAmount: {currency_id: 0}};
                     } else if (url === 'api/currency/accountCurrency') {
                         defaultData = [];
                     } else if (url.includes('history')) {
                         defaultData = {list: [], total: 0};
                     } else if (url.includes('ulist') || url.includes('currency')) {
                         defaultData = [];
                     }
                     return resolve({ code: 200, data: defaultData, success: true, message: "Error handled" });
                }

                // 处理 401 (未登录)
                if (resData.code === 401) {
                    console.log(`API ${url} 返回 401 (未登录)`);
                    // ... (保留之前的 401 跳转逻辑) ...
                    const requireLoginRoutes = ['/futures', '/flashOption'];
                    if (requireLoginRoutes.includes(window.location.pathname)) {
                        Message.warning({ content: i18n.global.t('please_login_first') });
                        setTimeout(() => { router.push('/login'); }, 1500);
                    }
                    // 注意：即使是401，也resolve并标记success: false，避免未捕获错误
                    return resolve({ code: 200, success: false, message: 'not login' });
                }

                // 成功情况
                return resolve(resData);

            }.bind(this)) // 需要绑定this才能在then里面调用this.request
            .catch(function (error) {
                 console.log(`API请求失败 (${url}):`, error.message); // 使用 log

                 // --- 处理 HTTP Status 错误 ---

                 // 401 Status 处理 (保留)
                 if (error.response?.status === 401) {
                    console.log(`API ${url} 返回 status 401 (未登录)`);
                    // ... (保留之前的 401 跳转逻辑) ...
                     const requireLoginRoutes = ['/futures', '/flashOption'];
                     if (requireLoginRoutes.includes(window.location.pathname)) {
                         Message.warning({ content: i18n.global.t('please_login_first') });
                         setTimeout(() => { router.push('/login'); }, 1500);
                     }
                    // 返回 resolve
                    return resolve({ code: 200, success: false, message: 'not login' });
                 }

                 // 登录API错误处理 - 保留原始错误消息
                 if (url === 'api/account/login') {
                     console.log('登录失败，保留原始错误消息');
                     // 如果响应包含原始错误信息，则使用它
                     if (error.response?.data) {
                         return resolve(error.response.data);
                     }
                     // 如果没有原始错误信息，则返回一个默认错误

                     return resolve({
                         code: 500,
                         success: false,
                         message: error.message || i18n.global.t('login_failed')
                     });
                 }


                 // 对注册/验证码接口：透传后端的错误结构，前端展示具体原因
                 if (passThroughErrorUrls.includes(url) && error.response?.data) {
                     return resolve({ ...error.response.data, success: false });
                 }

                 // 重试逻辑 (可选, 应该在 500 静默处理之后)
                 // 检查 status 是否存在，以及是否是需要静默的 500
                 const isSilent500 = error.response?.status === 500 && silent500Urls.includes(url);
                 if (retryCount < 2 && (url.includes('/currency') || url.includes('/dep')) && !isSilent500) {

                     console.log(`自动重试 ${url}, 重试次数: ${retryCount + 1}`);
                     const delay = (retryCount + 1) * 1000;
                     setTimeout(() => {
                         resolve(this.request(url, data, method, retryCount + 1));
                     }, delay);
                     return; // 返回，阻止后续处理
                 }

                 // **核心修改点 2**: 只有非静默 URL 的错误才弹框
                 // 检查是否是需要静默处理的 500 status 错误
                 if (isSilent500) {
                     console.log(`API ${url} 错误 (status 500) 被静默处理`);
                 } else {
                     // 对于其他所有未处理的错误(非401，非重试中的，非静默500)
                     // 可以考虑在这里显示通用错误，但为了完全静默初始化错误，注释掉
                     // Message.error({ content: i18n.global.t('network_request_failed') });
                     console.log(`未处理的API错误 (${url})，不弹框，将返回默认数据。`);
                 }

                 // 统一返回默认数据结构
                 let defaultData = {};
                  if (url === 'api/contract/list') {
                      defaultData = {position: [], entrust: [], entrustP: [], totalAmount: {currency_id: 0}};
                  } else if (url === 'api/currency/accountCurrency') {
                      defaultData = [];
                  } else if (url.includes('history')) {
                      defaultData = {list: [], total: 0};
                  } else if (url.includes('ulist') || url.includes('currency')) {
                      defaultData = [];
                  }

                 return resolve({
                     code: 200, // 返回成功状态码
                     data: defaultData,
                     success: false, // 标记业务不成功
                     message: "Request failed but handled gracefully"
                 });

            }.bind(this));
        });
    },
}